<template lang="pug">
el-dialog(
  custom-class="page__dialog order-placed-modal"
  visible
  :close-on-click-modal="false"
  @close="close")

  .page__dialog-header(slot="title")
    .page__dialog-info
      .page__dialog-title Add Your Payment Method

  .image
    img(src="/img/placement-program/add-card.webp")

  .notice.mt-4
    strong Add Your Payment Method
    p Add your card details for full access to your vendor dashboard.

  .page__dialog-footer(slot="footer")
    .actions
      el-button(
        type="primary"
        @click="go") Add your credit card

    el-checkbox.toggler(v-model="hidden" label="Never show this again")
</template>

<script>
export default {
  name: 'VendorAddCreditCardModal',

  data () {
    return {
      hidden: false
    }
  },

  methods: {
    close () {
      this.$emit('done', this.hidden)
      this.$emit('close')
    },
    go () {
      this.$router.push({ name: 'vendors-settings-payments' })
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .order-placed-modal {
    max-width: 400px;
    overflow: hidden;
  }
}
.image {
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-height: 224px;
    width: auto;
  }
}
.notice {
  line-height: 1.5em;
  margin: 1em 0;
}
.toggler {
  width: 100%;
  text-align: left;
  margin-top: 1em;
  ::v-deep {
    .el-checkbox__label {
      font-size: 12px;
    }
  }
}
</style>
